module.exports = __webpack_public_path__ + "static/media/app-store.da18b7d5.svg";